import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import Logo from "../ui/Logo";

const Navbar = ({ isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Close mobile menu on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Team", path: "/team" },
    { name: "Resources", path: "/resources" },
    { name: "Contact", path: "/contact" },
  ];

  const activeClass = "text-psa-gold-600 font-semibold";
  const inactiveClass =
    "text-gray-700 hover:text-psa-green-700 transition duration-200";

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        isScrolled
          ? "bg-white shadow-md py-3"
          : "bg-white/90 backdrop-blur-md py-4"
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          <Link
            to="/"
            className="flex items-center space-x-2"
            aria-label="PSA Home"
          >
            <Logo className="h-10 w-auto" />
          </Link>

          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden text-gray-700 hover:text-psa-green-700 focus:outline-none"
            onClick={() => setIsOpen(!isOpen)}
            aria-label={isOpen ? "Close menu" : "Open menu"}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  isActive ? activeClass : inactiveClass
                }
                end={link.path === "/"}
              >
                {link.name}
              </NavLink>
            ))}
            <a
              href="tel:+8801710908697"
              className="flex items-center gap-2 bg-psa-green-600 hover:bg-psa-green-700 text-white px-4 py-2 rounded-md transition duration-300"
            >
              <Phone size={16} />
              <span className="font-medium">Call Us</span>
            </a>
          </nav>
        </div>
      </div>

      {/* Mobile navigation */}
      {isOpen && (
        <nav className="md:hidden bg-white border-t mt-2 animate-fade-in">
          <div className="container mx-auto px-4 py-3 flex flex-col space-y-3">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.path}
                className={({ isActive }) =>
                  `${
                    isActive ? activeClass : inactiveClass
                  } py-2 px-4 block w-full`
                }
                onClick={() => setIsOpen(false)}
                end={link.path === "/"}
              >
                {link.name}
              </NavLink>
            ))}
            <a
              href="tel:+8801710908697"
              className="flex items-center justify-center gap-2 bg-psa-green-600 hover:bg-psa-green-700 text-white px-4 py-3 rounded-md mt-2 transition duration-300"
            >
              <Phone size={16} />
              <span className="font-medium">Call Us</span>
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
